/**
 * Homepage carousels and scroll interactions.
 */
const SCROLL_AMOUNT = 280;
class HorizontalScroller {
    constructor(container) {
        this.container = container;
        this.track = container.querySelector('[data-scroll-track], [data-carousel-track]');
        this.prevBtn = container.querySelector('[data-scroll-prev], [data-carousel-prev]');
        this.nextBtn = container.querySelector('[data-scroll-next], [data-carousel-next]');
        this.bind();
        this.updateButtons();
    }
    bind() {
        this.prevBtn?.addEventListener('click', () => this.scroll(-SCROLL_AMOUNT));
        this.nextBtn?.addEventListener('click', () => this.scroll(SCROLL_AMOUNT));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    }
    scroll(offset) {
        this.track.scrollBy({ left: offset, behavior: 'smooth' });
    }
    updateButtons() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const atStart = scrollLeft <= 4;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 4;
        if (this.prevBtn) {
            this.prevBtn.disabled = atStart;
        }
        if (this.nextBtn) {
            this.nextBtn.disabled = atEnd;
        }
    }
}
export function initHome() {
    document.querySelectorAll('[data-product-carousel], [data-category-scroll]').forEach((el) => {
        new HorizontalScroller(el);
    });
}
